import { render, staticRenderFns } from "./listCmp.vue?vue&type=template&id=245fca28&"
import script from "./listCmp.vue?vue&type=script&lang=ts&"
export * from "./listCmp.vue?vue&type=script&lang=ts&"
import style0 from "./listCmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports